/* eslint-disable */
import React from "react";
import sanitizeHtml from "sanitize-html";
import moment from "moment";
import "moment/locale/ja";
import camelizeUnderScore from "./camelizeUnderScore";
import ManageRoutes from "../../../app/javascripts/lib/js-routes/manageRoutesWrapper";
import { ActivityDate } from "../entities/activity_date";
import { ActivityLocation } from "../entities/activity_location";

const TEMPORARY_ID = 1000000000000;
import I18n from "../../../app/javascripts/lib/i18n-js/ja";

export function paramsSanitizer(params, options = {}) {
  params = nestedListSanitizer(params);
  params = deleteTemporaryIds(params);
  params = nullToEmptyString(params);
  params = priceParamsSanitizer(params);
  params = activityLocationParamsSanitizer(params);
  params = hasOneParamsSanitizer(params);
  return params;
}

export function paramsSanitizerForPics(params) {
  params = PicsParamsSanitizer(params);
  return params;
}

const deleteTemporaryIds = (params) => {
  return deepMapValues(params, (value, path) => {
    const key = path.split(".").slice(-1)[0];
    if (key === "id") {
      value = value > TEMPORARY_ID ? "" : value;
    }
    return value;
  });
};

const nullToEmptyString = (params) => {
  return deepMapValues(params, (value) => {
    return value == null ? "" : value;
  });
};

const priceParamsSanitizer = (params) => {
  if ("prices_attributes" in params) {
    params.prices_attributes.forEach((pa, ix, arr) => {
      if (pa.is_transportation_cost_included == false) {
        pa.transportation_cost = 0;
      }
      delete pa.is_transportation_cost_included;
    });
  }
  return params;
};

const nestedListSanitizer = (params) => {
  Object.keys(params).forEach(function (key) {
    if (key.includes("_attributes") && Array.isArray(params[key])) {
      params[key].forEach(function (item, idx) {
        if (checkEmpty(key, item) && item.length > 1 && idx == 0) {
          item._destroy = 1;
        }
      });
    }
  });
  return params;
};

// NOTE: has_oneをNestedListで処理しているものは最初のオブジェクトのみにする
const hasOneParamsSanitizer = (params) => {
  params = extractFirstElementIfArray(params, "age_group_attributes");
  params = extractFirstElementIfArray(params, "activity_term_attributes");
  params = extractFirstElementIfArray(params, "activity_frequent_attributes");
  params = extractFirstElementIfArray(params, "activity_period_attributes");
  return params;
};

const extractFirstElementIfArray = (params, key) => {
  if (key in params) {
    const array = params[key];
    if (Array.isArray(array) && array.length > 0) {
      params[key] = array[0];
    }
  }
  return params;
};

// ActivityLocationの has_one 関連を配列からオブジェクトに変換
const activityLocationParamsSanitizer = (params) => {
  if ("activity_locations_attributes" in params && Array.isArray(params.activity_locations_attributes)) {
    params.activity_locations_attributes = params.activity_locations_attributes.map((location) => {
      // _destroy が設定されている場合、子の属性を除外
      // （dependent: :destroy で自動削除されるため）
      if (location._destroy) {
        const { address_detail_attributes, access_attributes, ...rest } = location;
        return rest;
      }

      // address_detail_attributes を配列→オブジェクトに変換
      if (Array.isArray(location.address_detail_attributes) && location.address_detail_attributes.length > 0) {
        location.address_detail_attributes = location.address_detail_attributes[0];
      }

      // access_attributes を配列→オブジェクトに変換
      if (Array.isArray(location.access_attributes) && location.access_attributes.length > 0) {
        location.access_attributes = location.access_attributes[0];
      }

      return location;
    });
  }
  return params;
};

const checkEmpty = (type, item) => {
  var flg = true;
  const defaultValues = getPrototypeOfItem(type.replace("_attributes", "")) ? getPrototypeOfItem(type.replace("_attributes", "")) : [];
  Object.keys(omitKeys(item, ["id"])).forEach(function (key) {
    if (String(key) in defaultValues) {
      if (defaultValues[key] != item[key]) {
        flg = false;
      }
    }
  });
  return flg;
};

function deepMapValues(object, callback, propertyPath = "") {
  if (Array.isArray(object)) {
    return object.map((value, index) => deepMapValues(value, callback, `${propertyPath}[${index}]`));
  }
  if (typeof object === "object" && object !== null && !(object instanceof Date) && !(object instanceof RegExp) && !(object instanceof Function)) {
    const mappedObject = {};
    Object.keys(object).forEach((key) => {
      mappedObject[key] = deepMapValues(object[key], callback, propertyPath ? `${propertyPath}.${key}` : key);
    });
    return mappedObject;
  }
  return callback(object, propertyPath);
}

export function isBlank(str) {
  // stringがnullかundefinedか空白の時にtrue
  return !str || /^\s*$/.test(str);
}

const omitKeys = (obj, keys) => {
  var omitted = {};
  for (var key in obj) {
    if (keys.indexOf(key) == -1) {
      omitted[key] = obj[key];
    }
  }
  return omitted;
};

export function getPrototypeOfItem(type, correctItems) {
  correctItems = correctItems ? correctItems : [];
  const f = {
    prices: {
      id: Date.now(),
      name: "",
      is_not_pair: false,
      is_transportation_cost_included: false,
      lower_price: 0,
      upper_price: 0,
      wage_type: "hourly",
      transportation_cost: 0,
    },
    remarkable_points: {
      id: Date.now(),
      text: "",
    },
    additional_questions: {
      id: Date.now(),
      name: "",
      necessary: false,
      kind: "text",
      number: correctItems.length + 1,
      description: "",
      answer_choices_attributes: [],
    },
    answer_choices: {
      name: `選択肢${correctItems.length + 1}`,
      id: Date.now(),
    },
    pictures: {
      id: Date.now(),
      description: "",
      file: "",
      picture_type: "",
      url: "",
    },
    additional_contents: {
      id: Date.now(),
      heading: "",
      content: "",
      position: 0,
    },
    user_achievements: {
      id: Date.now(),
      headline: "",
      description: "",
      year: 2000,
      month: 0,
      day: 0,
    },
    user_support_participations: {
      id: Date.now(),
      headline: "",
      description: "",
    },
    age_group: {
      id: Date.now(),
      elementary_and_junior_high_school_students: "",
      high_schooler: "",
      college_students: "",
      member_of_society_20s: "",
      member_of_society_30s: "",
      member_of_society_40s: "",
      member_of_society_50s_and_above: "",
    },
    activity_dates: {
      id: Date.now(),
      start_date: "",
      end_date: "",
      is_not_pair: true,
      start_time: "",
      end_time: "",
    },
    activity_term: {
      id: Date.now(),
      lower_limit: "",
      upper_limit: "",
    },
    activity_frequent: {
      id: Date.now(),
      lower_limit: "",
      upper_limit: "",
    },
    activity_period: {
      id: Date.now(),
      start_date: "",
      end_date: "",
    },
    participation_steps: {
      id: Date.now(),
      name: "",
      description: "",
      position: correctItems.length,
    },
    activity_locations: {
      id: Date.now(),
      frontendId: `loc_${Date.now()}`,
      prefecture_or_country_area_id: "",
      city_id: "",
      ward_id: "",
      description: "",
      address_detail_attributes: [
        {
          address_line: "",
          latitude: 0,
          longitude: 0,
        },
      ],
      access_attributes: [
        {
          description: "",
        },
      ],
    },
  };
  return f[type];
}

const PicsParamsSanitizer = (params) => {
  if ("pictures_attributes" in params) {
    params.pictures_attributes.forEach((pa, ix, arr) => {
      if (typeof pa.file != "object" && pa.description == null) {
        pa.description = "";
      }
      if (typeof pa.file != "object") {
        delete pa.file;
      }
    });
  }
  return params;
};

export function getArticleUrl(props) {
  if (props.id == null) return "";
  return isRevenueShare(props) ? ManageRoutes.job_article_path(props.id) : ManageRoutes.volunteer_article_path(props.id);
}

export function getEntryUrl(props) {
  return isRevenueShare(props) ? ManageRoutes.job_new_contact_path(props.id) : ManageRoutes.volunteer_new_contact_path(props.id || 1);
}

export function getSpreadArticleUrl(articleId) {
  if (articleId == null) return "";
  return `${window.origin}${ManageRoutes.spread_article_path(articleId)}`;
}

export function getItemName(kind, column) {
  kind = kind == null ? "singly" : kind;
  return I18n.t(`${kind}_${column}_item_name`);
}

const PART_TIMER = ["3", "4"];
export function displayName(state) {
  const kind = state.kind;
  const working_form_ids = state.working_form_ids;
  var display_name = {
    intern: "インターン",
    probono: "プロボノ",
    tour: "海外プログラム",
    event: "イベント",
    singly: "ボランティア",
    member: "ボランティア",
    job: "求人",
  }[kind];
  if (display_name == "求人" && working_form_ids.every((i) => PART_TIMER.includes(i))) {
    display_name = "アルバイト";
  }
  display_name = display_name == undefined ? "募集" : display_name;
  return display_name;
}

export function userdisplayName(user) {
  var display_name = {
    public_company: "企業",
    student_group: "団体",
    voluntary_organization: "団体",
    other: "団体",
    municipality: "自治体",
  }[user.corporate_status];
  display_name = display_name == undefined ? "法人" : display_name;
  return display_name;
}

export function displayDateTime(time) {
  var datetime = moment(time).format("YYYY/MM/DD HH:mm");
  return datetime.toString();
}
export function displayDate(time) {
  var datetime = moment(time).format("YYYY/MM/DD");
  return datetime.toString();
}

export function get_time_diff(time) {
  moment.locale("ja");
  if (!time) {
    return false;
  }
  // var diff = moment.duration(moment().diff(time));
  var diff = moment(time).fromNow();
  return diff;
}

export function setLastActivityDate(activity_dates) {
  const last_activity_date = activity_dates
    .sort((a, b) => {
      if (a.price < b.price) return -1;
      if (a.price > b.price) return 1;
    })
    .at(-1);
  return last_activity_date.start_date;
}

export function isRevenueShare(state) {
  return state.kind == "job" || state.price_category == "part_time";
}

export function setCurrentTags(genre_ids, items) {
  const { tags, genre_tag_ids } = items;
  const target_tag_ids = genre_tag_ids.filter((g_t) => genre_ids.includes(g_t.id.toString())).flatMap((g_t) => g_t.tag_ids);
  const unique_target_tag_ids = target_tag_ids.filter((value, index, self) => self.indexOf(value) === index);
  const tags_for_genre_ids = tags.filter((tag) => unique_target_tag_ids.includes(tag.value));
  return tags_for_genre_ids;
}

export function computeJobFee(article, items) {
  var working_forms = article.working_form_ids;
  if (working_forms.length == 0) {
    working_forms = [4];
  }
  const user = article.user;
  const isShortTerm = article.always_active ? ["over_week", "two_or_three_days", "single_day"].includes(article.term_category) : false;
  var prices = isShortTerm ? [30000, 30000, 5000, 5000, 5000] : [30000, 30000, 10000, 10000, 10000];
  if (working_forms.length == 0) {
    prices = false;
  } else if (user.corporate_status == "public_company" || !user.corporate_status) {
    prices = prices.map((p) => {
      return (p *= 2);
    });
  } else {
    working_forms.map((id) => {
      if (["1", "2"].includes(id)) {
        prices[Number(id) - 1] = 30000;
      } else if ((["3", "4", "5"].includes(id) || article.price_category == "part_time") && isShortTerm) {
        prices[Number(id) - 1] = 5000;
      } else if (["3", "4", "5"].includes(id) || article.price_category == "part_time") {
        prices[Number(id) - 1] = 10000;
      }
    });
  }
  return (
    <span>
      {working_forms.map((id) => (
        <span className="priceItems" key={`job_fee-${id}`}>
          {items.working_forms.find((v) => v.value === String(id)).label}
          の場合は{prices[Number(id) - 1].toLocaleString()}円<br />
        </span>
      ))}
    </span>
  );
}

export function If(props) {
  if (props.condition) {
    return props.children;
  } else {
    return false;
  }
}

export function Trow(props) {
  if (props.need_columns.includes(props.for)) {
    return <tr className={`inputBox ${camelizeUnderScore(`is_${props.for}`)}`}>{props.children}</tr>;
  } else {
    return false;
  }
}

export function richHtmlFormatter(html) {
  if (!html) {
    return false;
  }
  var FormattedHtml = simpleFormat(html);
  var cleanHtml = sanitizeHtml(FormattedHtml, {
    allowedTags: sanitizeHtml.defaults.allowedTags.concat(["iframe", "img", "h2"]).filter((tag) => !["a", "h4", "h5", "h6"].includes(tag)),
    allowedAttributes: {
      img: sanitizeHtml.defaults.allowedAttributes.img.concat(["alt", "width", "height", "style"]),
      iframe: ["src", "width", "height", "frameborder", "allowfullscreen", "style"],
    },
  });
  return FormattedHtml;
}

export function richHtmlSanitizer(html) {
  if (!html) {
    return false;
  }
  var simpleFormatHtml = richHtmlFormatter(html);
  var cleanHtml = sanitizeHtml(simpleFormatHtml, {
    allowedTags: sanitizeHtml.defaults.allowedTags.concat(["iframe", "img", "h2"]).filter((tag) => !["a", "h4", "h5", "h6"].includes(tag)),
    allowedAttributes: {
      img: sanitizeHtml.defaults.allowedAttributes.img.concat(["alt", "width", "height", "style"]),
      iframe: ["src", "width", "height", "frameborder", "allowfullscreen", "style"],
    },
    textFilter: (text) => {
      var new_text = "";
      new_text = urlFilter(text);
      return emailFilter(new_text);
    },
  });
  return cleanHtml;
}

function urlFilter(text) {
  const expression = /https?:\/\/(?!activo\.jp(?:[:\/?#]|$))[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}([\/?#]\S*)?/gi;
  const urlRegex = new RegExp(expression);
  const new_text = text.replace(urlRegex, "");
  return new_text;
}

function emailFilter(text) {
  const expression = /([a-zA-Z0-9._-]+@[a-zA-Z0-9._-]+\.[a-zA-Z0-9._-]+)/gi;
  const emailRegex = new RegExp(expression);
  const new_text = text.replace(emailRegex, "");
  return new_text;
}

// 文字列を<p>で括る
// 改行は<br />を付与
// 連続した改行は、</p><p>を付与
function simpleFormat(str) {
  str = str.replace(/\r\n?/, "\n");
  str = $.trim(str);
  if (str.length > 0) {
    str = str.replace(/\n\n+/g, "</p><p>");
    str = str.replace(/\n/g, "<br />");
    str = "<p>" + str + "</p>";
  }
  return str;
}

export function textAreaFormat(text) {
  if (!text) {
    return false;
  }
  text = text.replace(/\r\n/g, "<br />");
  text = text.replace(/(\n|\r)/g, "<br />");
  text = `<p>${text}</p>`;
  return text;
}

export function showArrayItems(ids, items, name) {
  return (
    <ul>
      {items
        .filter((item) => ids.includes(item.value.toString()))
        .map((item) => (
          <li key={`show-${name}-${item.value}`} className={name}>
            {item.label}
          </li>
        ))}
    </ul>
  );
}

function isObject(value) {
  return value === Object(value);
}

function isArray(value) {
  return Array.isArray(value);
}

function isFile(value) {
  return value instanceof File;
}

export function objectToFormData(obj, fd, pre) {
  fd = fd || new FormData();

  Object.keys(obj).forEach(function (prop) {
    var key = pre ? pre + "[" + prop + "]" : prop;

    if (isObject(obj[prop]) && !isArray(obj[prop]) && !isFile(obj[prop])) {
      objectToFormData(obj[prop], fd, key);
    } else if (isArray(obj[prop])) {
      if (prop.includes("_ids")) {
        if (obj[prop].length === 0) {
          fd.append(`${key}[]`, "");
        } else {
          for (var i = 0; i < obj[prop].length; i++) {
            fd.append(`${key}[]`, obj[prop][i]);
          }
        }
      } else {
        obj[prop].forEach(function (value, idx) {
          var arrayKey = `${key}[${idx}]`;

          if (isObject(value) && !isFile(value)) {
            objectToFormData(value, fd, arrayKey);
          } else {
            fd.append(arrayKey, value);
          }
        });
      }
    } else {
      fd.append(key, obj[prop]);
    }
  });

  return fd;
}

export function getPrices(props) {
  var prices = [];
  if (["disuse"].includes(props.price_category)) {
    prices = ["無料"];
  } else if (["compensation", "part_time"].includes(props.price_category)) {
    // display_wage
    props.prices_attributes.forEach(function (price) {
      if (!price._destroy) {
        var wage = "";
        wage += price.name ? price.name : "";
        switch (price.wage_type) {
          case "hourly":
            wage += " 時給";
            break;
          case "daily":
            wage += " 日給";
            break;
          case "monthly":
            wage += " 月給";
            break;
        }
        if (price.is_not_pair || !price.upper_price) {
          wage += " " + commaSplit(price.lower_price) + "円";
        } else {
          wage += " " + commaSplit(price.lower_price) + " ~ " + commaSplit(price.upper_price) + "円";
        }
        prices.push(wage);
      }
    });
  } else {
    // display_cost
    props.prices_attributes.forEach(function (price) {
      if (!price._destroy) {
        var cost = "";
        cost += price.name ? price.name : "";
        if (price.is_not_pair || !price.upper_price) {
          cost += " " + commaSplit(price.lower_price) + "円";
        } else {
          cost += " " + commaSplit(price.lower_price) + " ~ " + commaSplit(price.upper_price) + "円";
        }
        cost += price.transportation_cost > 0 ? " (交通費" + commaSplit(price.transportation_cost) + "円含む)" : "";
        prices.push(cost);
      }
    });
  }
  if (prices.length == 0) {
    return false;
  } else {
    return (
      <div>
        <ul>
          {prices.map((price, idx) => (
            <li key={`show-prices-${idx}`}>{price}</li>
          ))}
        </ul>
        <p className="getDesc">{props.price_description}</p>
      </div>
    );
  }
}

export function commaSplit(num) {
  return String(num).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,");
}

// NOTE: 金額未入力時に backend が price_category を disuse にリセットするのを無視し、ローカル選択を維持する
export function reconcilePriceCategory(localCategory, savedCategory) {
  const isCostBasedLocal = !["disuse", "compensation", "part_time"].includes(localCategory);
  return isCostBasedLocal && savedCategory === "disuse" ? localCategory : savedCategory;
}

export function getGenderRate(props) {
  if (props.men_rate && props.women_rate) {
    return (
      <p>
        男性:{props.men_rate}%、女性:{props.women_rate}%
      </p>
    );
  } else {
    return false;
  }
}

export function get_remaining_item_count(props, type) {
  // たぶん全部$(':required:invalid').lengthでいける。
  if (type == "new") {
    const validateItems = Object.keys(props);
    let needItems = !props.kind ? ["title", "kind", "name", "corporate_status", "genres", "deadline"] : props.needColumns ? props.needColumns[`${props.kind}_need_columns`] : [];
    var count = 0;

    validateItems.forEach((item) => {
      if (needItems.includes(toItemName(item))) {
        if (check(item)) {
          count++;
        }
      }
    });
    return count;
  } else if (type == "edit") {
    return $(":required:invalid").length;
  }

  function check(item) {
    var flg = false;
    const Item = props[item];

    if ($(".inputBox" + toClassName(item) + " .p_required.isTrue").length == 1) {
      // required?
      if (item.toString() == "prices_attributes") {
        var attributes = JSON.parse(JSON.stringify(Item));
        flg = props.price_category == "disuse" ? false : attributes[0] ? !(attributes[0].is_not_pair ? attributes[0].lower_price : attributes[0].lower_price && attributes[0].upper_price) : false;
      } else if (item.toString() == "activity_dates_attributes") {
        var attributes = JSON.parse(JSON.stringify(Item));
        if (props.always_active) {
          flg = false;
        } else {
          const hasDateError = !(attributes[0]?.is_not_pair ? attributes[0]?.start_date : attributes[0]?.start_date && attributes[0]?.end_date);

          const hasTimeError = attributes[0] ? !!ActivityDate.validateTime(attributes[0]) : false;
          flg = hasDateError || hasTimeError;
        }
      } else if (item == "description") {
        flg = props.description ? false : true;
      } else {
        try {
          const input = $("input[name=" + item + "]").get(0);
          const textarea = $("textarea[name=" + item + "]").get(0);
          if ((input && !input.checkValidity()) || (textarea && !textarea.checkValidity())) {
            flg = true;
          }
        } catch (e) {
          // console.log(item+' ===> not existing!'); // 存在しないとfailを吐く
        }
      }
    } else if (item == "target") {
      flg = props.target ? false : true;
    } else if (item == "position_ids") {
      flg = props.position_ids.length > 0 ? false : true;
    } else if (item == "activity_dates_attributes") {
      if (props.always_active) {
        flg = isLowerLimitValid(props.activity_term_attributes);
      } else {
        flg = false;
      }
    } else if (item == "activity_frequent_attributes") {
      flg = isActivityFrequentValid(props.activity_frequent_attributes);
    } else if (item == "activity_term_attributes") {
      if (props.always_active) {
        flg = isLowerLimitValid(props.activity_term_attributes);
      } else {
        flg = false;
      }
    } else if (item == "activity_period_attributes") {
      if (props.always_active) {
        flg = false;
      } else {
        flg = isActivityPeriodValid(props.activity_period_attributes);
      }
    } else if (item == "activity_locations_attributes") {
      flg = !isActivityLocationsValid(props.online_possibility, props.activity_locations_attributes, props.items?.areas?.abroad?.map((a) => parseInt(a.value)) || []);
    }
    // if(flg){console.log(item);}
    return flg;
  }

  function toItemName(PropsName) {
    switch (PropsName) {
      case "prices_attributes":
        return "get_prices";
      case "activity_dates_attributes":
        return "get_dates_or_terms";
      case "activity_term_attributes":
        return "get_terms_and_frequents";
      case "activity_frequent_attributes":
        return "get_terms_and_frequents";
      case "activity_period_attributes":
        return "get_terms_and_frequents";
      case "activity_locations_attributes":
        return "get_activity_locations";
      default:
        return PropsName.replace("_id", "");
    }
  }

  function toClassName(PropsName) {
    switch (PropsName) {
      case "prices_attributes":
        return ".isGetPrices";
      case "activity_dates_attributes":
        return ".isGetDatesOrTerms";
      case "activity_frequent_category":
        return ".isGetTermsAndFrequents";
      case "activity_term_attributes":
        return ".isGetDatesOrTerms";
      case "activity_frequent_attributes":
        return ".isGetTermsAndFrequents";
      case "activity_locations_attributes":
        return ".isGetActivityLocations";
      default:
        return camelizeUnderScore(".is_" + PropsName.replace("_ids", "s"));
    }
  }

  function isLowerLimitValid(attributes) {
    return attributes?.length > 0 ? (attributes[0].lower_limit && attributes[0].lower_limit !== "" ? false : true) : true;
  }

  function isActivityPeriodValid(attributes) {
    return attributes?.length > 0 ? (attributes[0].end_date ? false : true) : true;
  }

  function isActivityFrequentValid(attributes) {
    return attributes?.length > 0 ? (attributes[0].lower_limit !== undefined && attributes[0].lower_limit !== "" ? false : true) : true;
  }
}

export function getRefreshedNestedList(old_nested_list, new_nested_list) {
  var refreshed_nested_list = Object.assign([], old_nested_list);

  // すでにreact側で_destroyが付いていて、かつ、new_nested_listで同様のidがないものは削除する
  refreshed_nested_list = refreshed_nested_list.filter((item) => is_correct_item(item, new_nested_list));

  // すでにreact側で持っているidを更新
  new_nested_list.forEach(function (item, idx) {
    if (refreshed_nested_list[idx]) {
      refreshed_nested_list[idx]["id"] = item["id"];
    }
  });

  return refreshed_nested_list;

  function is_correct_item(item, new_nested_list) {
    const new_nested_list_ids = new_nested_list.map((item) => item.id);
    return !(item._destroy && !new_nested_list_ids.includes(item.id));
  }
}

export function handleQuestionsKindChange(additional_questions, items) {
  let new_additional_questions = additional_questions.map((aq) => {
    if (items.fixed_name_kinds.includes(aq.kind)) {
      aq.name = items.kinds.filter((k) => k.value == aq.kind)[0].label;
    }
    return aq;
  });
  return new_additional_questions;
}

export function capitalize(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

// HACK: 少し雑ですが取り急ぎ以下にプレースホルダーをまとめていきます。by小澤
export function placeholderText(column, kind, working_form_ids = []) {
  switch (column) {
    case "age_group_description":
      switch (kind) {
        case "member":
        case "probono":
          return `20代後半のメンバーが中心ですが、幅広い世代の方歓迎です。
様々な職業の方々が集まって活動しています。`;
        case "intern":
          return `インターンは現在大学生が◯名、大学院生が◯名ほど在籍しています。
幅広い年代の社会人ボランティアの方や職員とも関わる機会があります。`;
        case "job":
          const baito_id = 2;
          if (working_form_ids == [baito_id]) {
            return `学生のアルバイトと社員が半々ほどの職場です。`;
          } else {
            return `若手〜60代まで幅広い年代の方が活躍している職場です。`;
          }
        default:
          return `学生や30代の参加者が多いですが、幅広い年代・ご職業の方々にご参加いただいています。`;
      }
  }
}

export function isDatesOrTermEditMode(state) {
  const always_active = state.always_active;
  const dates = state.activity_dates_attributes || [];
  const term = state.activity_term_attributes || [];

  if (always_active) {
    if (term.length === 0) {
      return true;
    }
    const termItem = term[0];
    return termItem.lower_limit === undefined || termItem.upper_limit === undefined;
  }

  if (dates.length === 0) {
    return true;
  }
  return dates.some((dateItem) => {
    // dates.some は「一つでも true (エラー) があれば true」を返す（EditModeを維持する）

    if (ActivityDate.validateTime(dateItem)) {
      return true;
    }

    if (dateItem.is_not_pair) {
      return dateItem.start_date === null || dateItem.start_date === undefined || dateItem.start_date.trim() === "";
    } else {
      const startDate = new Date(dateItem.start_date);
      const endDate = new Date(dateItem.end_date);

      return dateItem.start_date === null || dateItem.start_date === undefined || dateItem.start_date.trim() === "" || dateItem.end_date === null || dateItem.end_date === undefined || dateItem.end_date.trim() === "" || isInvalidDate(startDate, endDate);
    }
  });
}

export function isTermAndFrequencyEditMode(state) {
  const { always_active, activity_term_attributes, activity_frequent_attributes, activity_period_attributes, activity_dates_attributes } = state;

  const frequent = activity_frequent_attributes?.length > 0 ? activity_frequent_attributes[0] : [];

  const dates = activity_dates_attributes || [];
  for (const dateItem of dates) {
    const startDate = new Date(dateItem.start_date);
    const endDate = new Date(dateItem.end_date);

    if (dateItem._destroy) {
      return false;
    }

    // NOTE: 活動時間のバリデーションチェック
    if (ActivityDate.validateTime(dateItem)) {
      return true;
    }

    if (dateItem.is_not_pair && (dateItem.start_date === null || dateItem.start_date === undefined || dateItem.start_date.trim() === "")) {
      return true;
    } else if (!dateItem.is_not_pair && (dateItem.start_date === null || dateItem.start_date === undefined || dateItem.start_date.trim() === "" || dateItem.end_date === null || dateItem.end_date === undefined || dateItem.end_date.trim() === "" || isInvalidDate(startDate, endDate))) {
      return true;
    }
  }

  if (always_active) {
    const term = activity_term_attributes?.length > 0 ? activity_term_attributes[0] : [];
    return term.lower_limit === undefined || term.lower_limit === 0 || frequent.lower_limit === undefined || frequent.lower_limit === "";
  } else {
    const period = activity_period_attributes?.length > 0 ? activity_period_attributes[0] : [];
    const startPeriod = new Date(period.start_date);
    const endPeriod = new Date(period.end_date);
    return period.end_date === null || isInvalidDate(startPeriod, endPeriod) || period.end_date === undefined || period.end_date.trim() === "" || frequent.lower_limit === undefined || frequent.lower_limit === "";
  }
}

export const getAliasFromCount = (count) => {
  const mapping = {
    day: 1,
    week: 2,
    month: 3,
    year: 4,
  };
  return mapping[count];
};

export function handleChangeSelectWithUnitValue(key_value, handleChange, id, setSelectedValue) {
  const updateKey = Object.keys(key_value)[0];
  let selectedValue = parseInt(key_value[updateKey], 10);
  const countBy = key_value.count_by;

  if (selectedValue) {
    let calculatedValue;
    if (countBy === "day") {
      calculatedValue = selectedValue;
    } else if (countBy === "week") {
      calculatedValue = selectedValue * 7;
    } else if (countBy === "month") {
      calculatedValue = Math.floor((365 * selectedValue) / 12);
    } else if (countBy === "year") {
      calculatedValue = selectedValue * 365;
    } else {
      calculatedValue = null;
    }
    if (calculatedValue > 999999) {
      calculatedValue = 0;
    }
    handleChange({ [updateKey]: calculatedValue }, id);
  } else if (updateKey === "upper_limit") {
    selectedValue = 999999;
  }

  setSelectedValue((prevState) => {
    if (updateKey === "lower_limit") {
      return {
        ...prevState,
        [updateKey]: selectedValue,
        lower_count: countBy,
      };
    }
    if (updateKey === "upper_limit") {
      return {
        ...prevState,
        [updateKey]: selectedValue,
        upper_count: countBy,
      };
    }
    return prevState;
  });
}

export function handleSetActivityTermInputValue(value, items) {
  const termInputAttributes = {
    lower_limit: "",
    lower_count: "",
    upper_limit: "",
    upper_count: "",
  };

  if (!value || value?.length === 0) {
    return termInputAttributes;
  }

  const { lower_limit, upper_limit } = value[0];

  const setTermAttributes = (initialLimit, type) => {
    let limit = initialLimit;
    const selectedValue = items.find((item) => item.alias === limit);

    if (limit === 0) {
      limit = null;
    }
    if (selectedValue) {
      const numberPattern = /\d+/;
      const numberMatch = selectedValue.label.match(numberPattern);
      const number = numberMatch ? parseInt(numberMatch[0], 10) : limit;

      if (selectedValue.label.includes("日間")) {
        termInputAttributes[`${type}_limit`] = limit;
        termInputAttributes[`${type}_count`] = "day";
      } else if (selectedValue.label.includes("週間")) {
        termInputAttributes[`${type}_limit`] = limit / 7;
        termInputAttributes[`${type}_count`] = "week";
      } else if (selectedValue.label.includes("ヶ月")) {
        termInputAttributes[`${type}_limit`] = number;
        termInputAttributes[`${type}_count`] = "month";
      } else if (selectedValue.label.includes("年間")) {
        termInputAttributes[`${type}_limit`] = number;
        termInputAttributes[`${type}_count`] = "year";
      }
    } else {
      termInputAttributes[`${type}_limit`] = limit;
      termInputAttributes[`${type}_count`] = "day";
    }
  };

  setTermAttributes(lower_limit, "lower");
  setTermAttributes(upper_limit, "upper");

  return termInputAttributes;
}

export function rearrangeItemsForJobOrIntern(frequentItems) {
  const items = [...frequentItems];
  const item9 = items[9];
  const item10 = items[10];
  items.splice(10, 1);
  items.splice(9, 1);
  items.unshift(item10);
  items.unshift(item9);
  return items;
}

export function prioritizeFrequentItems(items) {
  const priorityOrder = ["one_times_per_week", "two_times_per_week", "three_times_per_week", "four_times_per_week", "five_times_per_week", "two_times_per_month", "other", "occasional", "one_times_per_month", "three_times_per_month", "four_times_per_month", "one_time"];

  return items.sort((a, b) => {
    const indexA = priorityOrder.indexOf(a.value);
    const indexB = priorityOrder.indexOf(b.value);
    return indexA - indexB;
  });
}

export function handleSetSelectedSelectBoxValue(key, value, frequentItems, useLabel = false) {
  let selectedValue = "";
  if (value?.length > 0) {
    const limitValue = value[0][key];
    if (value[0]?.sub_monthly_type && key === "lower_limit") {
      selectedValue = frequentItems.find((item) => item.value === value[0]?.sub_monthly_type) || "";
    } else {
      selectedValue = frequentItems.find((item) => item.alias === limitValue) || "";
    }
  }
  if (useLabel && selectedValue) {
    selectedValue = selectedValue.label;
  }
  return selectedValue;
}

export function formatStartDate(dateString) {
  if (!dateString) return "";
  const options = {
    year: "numeric",
    month: "long",
    day: "numeric",
    weekday: "short",
  };
  return new Date(dateString).toLocaleDateString("ja-JP", options);
}

export function formatEndDate(startDateString, endDateString) {
  if (!endDateString) return "";
  const startDate = startDateString ? new Date(startDateString) : null;
  const endDate = new Date(endDateString);

  const optionsSameMonth = {
    day: "numeric",
    weekday: "short",
  };

  const optionsSameYear = {
    month: "long",
    day: "numeric",
    weekday: "short",
  };

  const optionsDifferentYear = {
    year: "numeric",
    month: "long",
    day: "numeric",
    weekday: "short",
  };

  if (startDate && startDate.getFullYear() === endDate.getFullYear()) {
    if (startDate.getMonth() === endDate.getMonth()) {
      return endDate.toLocaleDateString("ja-JP", optionsSameMonth);
    }
    return endDate.toLocaleDateString("ja-JP", optionsSameYear);
  }
  return endDate.toLocaleDateString("ja-JP", optionsDifferentYear);
}

export function handleSetActivityTermRadioValue(value, items, useLabel = false) {
  let radioValue = "";
  if (value?.length > 0) {
    const { lower_limit, upper_limit } = value[0];
    const isUpperMaxValue = upper_limit === 999999 || upper_limit === null;
    const selectedLowerValue = items.find((item) => item.alias === lower_limit);
    if (selectedLowerValue && isUpperMaxValue) {
      if (useLabel) {
        if (selectedLowerValue.value === "indefinite") {
          radioValue = "長期歓迎";
        } else {
          radioValue = selectedLowerValue.label;
        }
      } else {
        radioValue = selectedLowerValue.value;
      }
    } else {
      radioValue = "other";
    }
  }
  return radioValue;
}

export function isInvalidDate(start_date, end_date) {
  const startDate = new Date(start_date);
  const endDate = new Date(end_date);

  return endDate.getFullYear() < startDate.getFullYear() || (endDate.getFullYear() === startDate.getFullYear() && endDate.getMonth() < startDate.getMonth()) || (endDate.getFullYear() === startDate.getFullYear() && endDate.getMonth() === startDate.getMonth() && endDate.getDate() < startDate.getDate());
}

function checkRequiredRadioButtons(htmlIdForValidation) {
  const radioButtons = document.querySelectorAll(`#${htmlIdForValidation} .radioBoxList`);
  let flg = true;
  for (const radioButton of radioButtons) {
    const requiredInputs = radioButton.querySelectorAll('li input[type="radio"]:required');
    if (requiredInputs.length === 0) {
      continue;
    }
    const isAnyInputChecked = Array.from(requiredInputs).some((input) => input.checked);
    if (!isAnyInputChecked) {
      return false;
    }
  }
  return flg;
}

function validateJsAgeGroup(editItem, htmlIdForValidation) {
  let flg = editItem.every((item) => {
    if (Array.isArray(item)) {
      return item.length > 0;
    } else {
      return item !== "";
    }
  });

  return flg && checkRequiredRadioButtons(htmlIdForValidation);
}

export function validateByHtmlId(htmlIdForValidation, editItem) {
  let flg = true;
  if (htmlIdForValidation === "jsAgeGroupValidation") {
    flg = validateJsAgeGroup(editItem, htmlIdForValidation);
  }
  return flg;
}

// NOTE: HTMLの標準のバリデーションではなく、独自のバリデーションを行う
export function checkFormIsValid(formIdentifiers) {
  let invalidElements;

  const forms = document.querySelectorAll(`${formIdentifiers}`);
  invalidElements = document.querySelectorAll(":invalid");

  if (invalidElements.length == 0) {
    return true;
  } else {
    forms.forEach((form) => form.classList.add("isError"));
    toastr.warning("未入力の項目があります");
    return false;
  }
}

export function removeFormIsErrorClass() {
  const forms = document.querySelectorAll(".isError");
  forms.forEach((form) => form.classList.remove("isError"));
}

export function resetSaveBtns() {
  const save_btns = $("#jsFixTop > div > button");
  save_btns.prop("disabled", false);
  save_btns.first().text("公開する (無料)");
  save_btns.last().text("公開せずに続きを編集する");
}

export const handleChangeUserValue = (key_value, user, setUser) => {
  const update_key = Object.keys(key_value)[0];
  const update_value = key_value[update_key];

  if (typeof update_value === "object" && update_value !== null) {
    setUser({
      ...user,
      [update_key]: {
        ...user[update_key],
        ...update_value,
      },
    });
  } else {
    setUser({
      ...user,
      [update_key]: update_value,
    });
  }
};

export function isActivityLocationsValid(online_possibility, activity_locations_attributes, abroadAreaIds) {
  if (online_possibility === "online") return true;

  const activeLocations = (activity_locations_attributes || []).filter((loc) => !loc._destroy);
  if (activeLocations.length === 0) return false;

  const context = { abroadAreaIds: abroadAreaIds || [] };
  return activeLocations.every((loc) => ActivityLocation.validate(loc, context) === null);
}
